<script lang="ts">
  import type { Permission } from "$lib/api/contract";
  import { roleForPermission } from "$lib/auth/permissions";
  import EmptyState from "$lib/components/EmptyState.svelte";
  interface Props {
    permission: Permission;
    action?: string;
  }
  const { permission, action = "view this" }: Props = $props();
  const role = $derived(roleForPermission(permission));
</script>

<div class="denied">
  <h1 class="page-title" data-page-title tabindex="-1">Access restricted</h1>
  <EmptyState
    title="You don't have permission to {action}"
    description={`This requires the ${role} role in this organization. Ask an owner if you need access.`}
  />
</div>

<style>
  .denied {
    padding: 8px 0;
  }
</style>
